/** The final step's submit label when the caller gives none, as in SteppedModal.Formik. */
export const DEFAULT_SUBMIT_BUTTON_TEXT = "Save";
